import { SideNavLinkItem } from "@snapchat/snap-design-system";

/**
 *
 * @param itemKey Name that will be displayed for url route. Ex: /web-rtc
 * @param text Display text that will be shown for side navigation
 */
export const generateUseCaseLink = (itemKey: string, text: string): SideNavLinkItem => {
    return { itemKey, text, itemType: "link" };
};
